import type { VenueTransformed } from "~pages/Venues/types/venueTransformed.ts";
import type { Venue, VenueResources } from "~types/venue.ts";
import { transformVenue } from "./transformVenue.ts";

export const transformVenues = (items: Venue[], resources?: VenueResources): VenueTransformed[] =>
  items.map((item) => transformVenue(item, resources));
